import {useRef, useCallback} from 'react'

export function useDebounce<T extends (...args: any[]) => void>(
  callback: T,
  delay: number
): (...args: Parameters<T>) => void {
  const timer = useRef<NodeJS.Timeout | null>(null)

  const debouncedFn = useCallback(
    (...args: Parameters<T>) => {
      if (timer.current) {
        clearTimeout(timer.current)
      }

      timer.current = setTimeout(() => {
        // eslint-disable-next-line node/no-callback-literal
        callback(...args)
      }, delay)
    },
    [callback, delay]
  )

  return debouncedFn
}
